export default __webpack_public_path__ + "static/media/BinanceWallet.ec84e95a.svg";